// CR / VAT / Saudi national address rules by party type: 1 individual, 2 company, 3 government.
// Keep in line with ecarApiValidatePartyByType() in php/api/index.php, which enforces the same rules.
export function validatePartyByType(party, lang, vatKey = 'company_vatid') {
  const type = parseInt(party.customer_type || 1)
  if (type !== 2 && type !== 3) return ''

  const val = (key) => {
    const v = String(party[key] ?? '').trim()
    return v === 'undefined' || v === 'null' ? '' : v
  }

  if (!/^\d{15}$/.test(val(vatKey))) return lang.vat_15_digits_required
  if (type === 2 && val('crt_number') === '') return lang.crt_number_required
  if (!/^\d{4}$/.test(val('building_no'))) return lang.building_no_4_digits
  if (val('street_name') === '') return lang.street_name_required
  if (val('district') === '') return lang.district_required
  if (val('city') === '') return lang.city_required
  if (!/^\d{5}$/.test(val('zipcode'))) return lang.zipcode_5_digits
  if (!/^\d{4}$/.test(val('branch_number'))) return lang.additional_no_4_digits
  return ''
}
